import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChatWindow from '../components/ChatWindow';
import { useAuth } from '../contexts/AuthContext';

export default function ChatPage() {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const { impersonatedStudentId } = useAuth();
  const [currentSessionId, setCurrentSessionId] = useState<string | null>(
    sessionId || null
  );
  const prevImpersonationRef = useRef(impersonatedStudentId);

  // Reset session when impersonation changes (skip initial mount)
  useEffect(() => {
    if (prevImpersonationRef.current !== impersonatedStudentId) {
      prevImpersonationRef.current = impersonatedStudentId;
      setCurrentSessionId(null);
      navigate('/', { replace: true });
    }
  }, [impersonatedStudentId, navigate]);

  // Sync state when URL session param changes (e.g. sidebar click)
  useEffect(() => {
    setCurrentSessionId(sessionId || null);
  }, [sessionId]);

  const handleSessionCreated = (newSessionId: string) => {
    setCurrentSessionId(newSessionId);
    navigate(`/chat/${newSessionId}`, { replace: true });
  };

  return (
    <ChatWindow
      sessionId={currentSessionId}
      onSessionCreated={handleSessionCreated}
    />
  );
}
